import { Box, Typography } from "@mui/material";
import { Logo, rescueRed } from "@rescuetablet/theme";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { t } = useTranslation("welcome");

  return (
    <>
      <Box
        sx={{
          bgcolor: rescueRed[500],
          color: "common.white",
          p: 2,
          textAlign: "center",
          zIndex: 1,
          borderTopLeftRadius: (theme) => ({ lg: theme.shape.borderRadius }),
          borderTopRightRadius: (theme) => ({ lg: theme.shape.borderRadius }),
        }}
      >
        <Logo height="55" />
      </Box>
      <Typography
        component="h1"
        variant="h5"
        sx={{
          bgcolor: "grey.700",
          color: "common.white",
          py: 2,
          textAlign: "center",
          zIndex: 1,
        }}
      >
        {t("tag")}
      </Typography>
    </>
  );
}
